// Default/minimum desktop width; the dealer can widen the hub up to the maximum.
export const HELP_HUB_WIDTH = 355
export const HELP_HUB_MAX_WIDTH = 600
export const HELP_HUB_WIDTH_KEY = 'helpHubWidth'
// From this viewport width the Inspector fits the expanded sidebar, the open Help Hub and its 300px side columns; from 2xl up to it, opening one closes the other and the columns narrow.
export const HELP_HUB_BESIDE_SIDEBAR_WIDTH = 1800

export const HELP_HUB_PANEL_ID = 'help-hub-panel'
export const HELP_HUB_TOGGLE_ID = 'help-hub-toggle'

// localStorage key for the dealer's open/closed choice; unset means open.
export const HELP_HUB_OPEN_KEY = 'helpHubOpen'
// localStorage key for the `?help=` slug the hub was last closed on, where the dealer's next opening returns; unset is the top level.
export const HELP_HUB_LAST_SLUG_KEY = 'helpHubLastSlug'

// The hub's open help page is addressed by this route query: `?help=<slug>`.
export const HELP_HUB_QUERY = 'help'

// Slug of the Getting Started list, where "View all" leads.
export const HELP_HUB_GET_STARTED_SLUG = 'getting-started'

// `chat` is also that tab's `?help=` slug; the Help tab has none.
export const HELP_HUB_TAB = Object.freeze({ HELP: 'help', CHAT: 'chat' })

export const HELP_HUB_TABS = [
  { label: 'Help', value: HELP_HUB_TAB.HELP },
  { label: 'Chat', value: HELP_HUB_TAB.CHAT },
]

// The Chat tab's "View all" pages, each its own `?help=` slug: every conversation, ticket or question, under a field that filters them.
export const HELP_HUB_CHAT_PAGE = Object.freeze({ CONVERSATIONS: 'chat-conversations', TICKETS: 'chat-tickets', QUESTIONS: 'chat-questions' })

// An open thread's `?help=` slug names its ticket by number: `ticket-32193`.
export const HELP_HUB_TICKET_SLUG = 'ticket'

// Where a Help tab search result comes from; a result's row names its source on a badge.
export const HELP_HUB_SEARCH_SOURCE = Object.freeze({ GET_STARTED: 'get-started', WHATS_NEW: 'whats-new', HELP_TOPICS: 'help-topics' })

// The "Help Categories" rows, in the design's order, each a category page of the support center; static until the Help content API serves them.
export const HELP_HUB_CATEGORIES = [
  { title: 'Marketplace Setup', href: 'https://support.carddealerpro.com/hc/en-us/categories/connections' },
  { title: 'Card Templates & Pricing', href: 'https://support.carddealerpro.com/hc/en-us/categories/templates' },
  { title: 'Inventory Management', href: 'https://support.carddealerpro.com/hc/en-us/categories/inventory' },
  { title: 'Shipping & Orders', href: 'https://support.carddealerpro.com/hc/en-us/categories/fulfillment' },
  { title: 'Account & Billing', href: 'https://support.carddealerpro.com/hc/en-us/categories/account' },
]
